import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, PDFModule, ExcelModule } from '@progress/kendo-angular-grid';
import { TextMaskModule } from 'angular2-text-mask';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { Daterangepicker } from 'ng2-daterangepicker';
import { AgmCoreModule } from '@agm/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '@app/shared/shared.module';
import { CanDeactivateGuard } from '@app/base/shared';
import { CommonModule, DatePipe } from '@angular/common';


import {
  BuilderComponent,
  RequestComponent,
  HomeComponent,
  AddressesComponent,
  AgreementsComponent,
  InformationComponent,
  LocationComponent,
  LotComponent,
  PremiseComponent,
  CommercialPremiseComponent,
  ResidentialPremiseComponent,
  MixedPremiseComponent,
  SubDivisionPremiseComponent,
  NewRequestComponent,
  NewUserComponent,
  AcknowledgeComponent,
  MainRequestComponent,
  SubdivisionRequestComponent,
  ServiceRequestComponent,
  ServiceLotRequestComponent,
  ServiceActivateRequestComponent,
  ServiceNewRequestComponent,
  ReviewComponent,
  SubsidiaryComponent,
  SubsidiarySearchfilterPipe,
  TypeComponent,
  LetterComponent,
  RequestLotComponent,
  BcaAgreementsComponent,
  ContractComponent,
  AcceptContractComponent,
    BuilderService,
    LetterSummeryComponent
} from '@app/modules/builder';
import { PaymentComponent, AddSubsidiaryComponent } from '../components';

const routes: Routes = [
  {
    path: 'request/new',
    component: NewRequestComponent,
    children: [
      { path: 'location', component: LocationComponent, canDeactivate: [CanDeactivateGuard], data:
       { title: 'Builder FIRST | Service Address' } },
      { path: 'type', component: TypeComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Builder FIRST | Request Type' } },
      { path: 'information', component: InformationComponent, canDeactivate: [CanDeactivateGuard], data:
       { title: 'Builder FIRST | About Applicant' } },
      { path: 'addresses', component: AddressesComponent, canDeactivate: [CanDeactivateGuard], data:
       { title: 'Builder FIRST | Site Details' } },
      { path: 'premise', component: PremiseComponent, canDeactivate: [CanDeactivateGuard], data: { title: 'Builder FIRST | Premise' } },
      { path: 'review', component: ReviewComponent, canDeactivate: [CanDeactivateGuard], data: { title:
         'Builder FIRST | Review Request' } },
      { path: 'acknowledge', component: AcknowledgeComponent, canDeactivate: [CanDeactivateGuard], data:
       { title: 'Builder FIRST | Acknowledge' } }
    ]
  },
  { path: 'requestlot/:id/:navFlag', component: RequestLotComponent,  canDeactivate: [CanDeactivateGuard],
   data: { title: 'Builder FIRST | Request Additional Lots' }},

  { path: 'lot/new/:id/:builderId/:navFlag', component: LotComponent,
  canDeactivate: [CanDeactivateGuard], data: { title: 'Builder FIRST | Create New Lot' } },
  { path: 'contract/:userr/:id', component: ContractComponent, canDeactivate: [CanDeactivateGuard],
   data: { title: 'Contract | Home' } },
   { path: 'contract/:user', component: ContractComponent, canDeactivate: [CanDeactivateGuard],
   data: { title: 'Contract | Home' } },
  { path: 'contractaccept/:id/:requestType', component: AcceptContractComponent, canDeactivate: [CanDeactivateGuard],
   data: { title: 'Contract | Accept Contract' }},
  { path: 'contract', component: ContractComponent, canDeactivate: [CanDeactivateGuard],
   data: { title: 'Contract | Home' } },
  { path: 'contractaccept', component: AcceptContractComponent, canDeactivate: [CanDeactivateGuard],
   data: { title: 'Contract | Accept Contract' } },
   { path: 'payment/:user', component: PaymentComponent, canDeactivate: [CanDeactivateGuard],
   data: { title: 'Contract | Payment' } },
   { path: 'letter', component: LetterComponent,  canDeactivate: [CanDeactivateGuard], data:
   { title: 'Builder FIRST | Gas Availability Letter' } },
   { path: 'payment', component: PaymentComponent, canDeactivate: [CanDeactivateGuard],
   data: { title: 'Contract | Payment' } },
   { path: 'payment/:user/:id', component: PaymentComponent, canDeactivate: [CanDeactivateGuard],
   data: { title: 'Contract | Payment' } },
    {
        path: 'gas-availability-letters', component: LetterSummeryComponent, canDeactivate: [CanDeactivateGuard],
        data: { title: 'Builder | Gas Availability Letters' }
    },

   { path: 'subsidiaries', component: SubsidiaryComponent, canDeactivate: [CanDeactivateGuard],
   data: { title: 'Builder FIRST | Subsidiaries' },
   children: [
    { path: 'add-subsidiary/:id', component: AddSubsidiaryComponent,
    canDeactivate: [CanDeactivateGuard], data: { title: 'Builder FIRST | Add Subsidiary' }, outlet:  'add-subsidiary'}
   ]
  },
  { path: 'new-user', component: NewUserComponent, canDeactivate: [CanDeactivateGuard],
  data: { title: 'Builder FIRST | Add New User' } },
  { path: 'agreements', component: AgreementsComponent,
  canDeactivate: [CanDeactivateGuard], data: { title: 'Builder FIRST | Home' } },
  {
    path: '',
    component: BuilderComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      { path: 'home', component: HomeComponent, canDeactivate: [CanDeactivateGuard],
       data: { title: 'Builder FIRST | Home' }  },
       {
        path: 'request/:id',
        component: RequestComponent,
        children: [
          { path: 'subdivision', component: SubdivisionRequestComponent, canDeactivate: [CanDeactivateGuard],
           data: { title: 'Builder FIRST | Home' } },
          { path: 'main', component: MainRequestComponent,
           canDeactivate: [CanDeactivateGuard], data: { title: 'Builder FIRST | Home' }  },
          { path: 'service', component: ServiceRequestComponent, canDeactivate: [CanDeactivateGuard],
           data: { title: 'Builder FIRST | Home' },
            children: [
              { path: 'details/:id', component: ServiceLotRequestComponent, canDeactivate: [CanDeactivateGuard],
               data: { title: 'Builder FIRST | Lot Details' }, outlet:  'lot-details'},
              { path: 'activate/:id', component: ServiceActivateRequestComponent, canDeactivate: [CanDeactivateGuard],
               data: { title: 'Builder FIRST | Activate Service' }, outlet: 'activate-service' },
              { path: 'deactivate/:id', component: ServiceActivateRequestComponent, canDeactivate: [CanDeactivateGuard],
               data: { title: 'Builder FIRST | Deactivate Service' }, outlet: 'activate-service' },
              { path: 'new/:id', component: ServiceNewRequestComponent, canDeactivate: [CanDeactivateGuard],
               data: { title: 'Builder FIRST | Request Service' }, outlet: 'request-service' }
            ]
          },
          { path: 'bca-agreements', component: BcaAgreementsComponent, canDeactivate: [CanDeactivateGuard],
          data: { title: 'Builder FIRST | Home' } },
        ]
      }
    ]
  }
];
// @NgModule ({
//   imports: [HttpClientModule],
//   providers: [{ provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true }  ]
// })
export class InterceptorModule { }
@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    NgxPaginationModule,
    Daterangepicker,
    PDFModule,
    ReactiveFormsModule,
    DropDownsModule,
    GridModule,
    TextMaskModule,
    ExcelModule,
    // InterceptorModule,
     //LandingModule,

    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyB07y6RxtlvdnrzAnBH-N0oPg2pjuyPpgo',
      libraries: ['places']
    }),
    RouterModule.forChild(routes)
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  declarations: [
    BuilderComponent,
    HomeComponent,
    AddressesComponent,
    AgreementsComponent,
    AcknowledgeComponent,
    InformationComponent,
    LocationComponent,
    LotComponent,
    PremiseComponent,
    CommercialPremiseComponent,
    ResidentialPremiseComponent,
    MixedPremiseComponent,
    SubDivisionPremiseComponent,
    NewRequestComponent,
    RequestComponent,
    MainRequestComponent,
    SubdivisionRequestComponent,
    ServiceRequestComponent,
    AddSubsidiaryComponent,
    ServiceLotRequestComponent,
    ReviewComponent,
    NewUserComponent,
    SubsidiaryComponent,
    SubsidiarySearchfilterPipe,
    TypeComponent,
    LetterComponent,
    ServiceActivateRequestComponent,
    ServiceNewRequestComponent,
    RequestLotComponent,
  BcaAgreementsComponent,
  ContractComponent,
  AcceptContractComponent,
      PaymentComponent,
      LetterSummeryComponent


  ],
  providers: [BuilderService]
})
export class BuilderModule { }
